const indexItems = [
  { title: '最新域名收录', desc: '实时追踪51cg官方域名变更，第一时间更新可用网址入口', icon: 'ri-link-m', tag: '实时' },
  { title: '平台功能解析', desc: '全方位介绍51cg平台核心功能模块与操作方式', icon: 'ri-function-line', tag: '指南' },
  { title: '访问问题排查', desc: '汇总常见访问异常及解决方案，确保稳定连接', icon: 'ri-tools-line', tag: '实用' },
  { title: '安全访问指南', desc: '提供安全访问建议，识别仿冒站点与钓鱼风险', icon: 'ri-shield-check-line', tag: '重要' },
  { title: '内容更新动态', desc: '追踪51cg平台内容更新节奏与重点栏目变化', icon: 'ri-refresh-line', tag: '动态' },
  { title: '移动端适配', desc: '介绍51cg移动端访问方式与适配优化方案', icon: 'ri-smartphone-line', tag: '移动' },
  { title: '社区动态汇总', desc: '整理51cg社区热点讨论与用户关注焦点', icon: 'ri-chat-3-line', tag: '社区' },
  { title: '使用技巧分享', desc: '收集实用的51cg平台使用技巧与效率提升方法', icon: 'ri-lightbulb-line', tag: '技巧' },
  { title: '版本更新记录', desc: '记录平台功能迭代与界面优化的关键版本节点', icon: 'ri-history-line', tag: '记录' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">专题索引</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">快速定位您关心的51cg平台相关内容，按主题分类浏览</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <a
              key={item.title}
              href="#updates"
              className="group flex items-start gap-4 p-5 bg-background-50 rounded-xl border border-background-200/60 hover:border-primary-200 transition-all duration-200 cursor-pointer no-underline"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-50 text-primary-600 flex-shrink-0 group-hover:bg-primary-100 transition-colors">
                <i className={item.icon}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm font-bold text-foreground-900 truncate">{item.title}</h3>
                  <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-accent-50 text-accent-600 font-medium whitespace-nowrap flex-shrink-0">
                    {item.tag}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}